import { normalize } from 'normalizr';

import { callApi, pageToOffsetParams } from 'utils/api';
import * as schemas from 'schemas';
import { findCommentRepliesType } from 'commentsResourceTypes';

export function commentsFetch(page, pageSize, { resourceType, resourceId, sort = 'recent', dateOffset = null }) {
  let query = {
    resourceType,
    resourceId,
    ...pageToOffsetParams(page, pageSize)
  };

  if(dateOffset) {
    query = {...query, dateOffset};
  }
  else {
    query = {...query, sort};
  }

  return callApi('/comments', { query })
  .then(json => {
    const { comments, meta }  = json;
    const { result, entities } = normalize(comments, schemas.commentsArraySchema);

    if(comments.length > 0) {
      Object.keys(entities.comments).forEach(commentId => {
        const comment = entities.comments[commentId];

        comment.resourceType = resourceType;
        comment.resourceId = resourceId;
        comment.repliesQueryString = JSON.stringify({
          resourceId: comment.id,
          resourceType: findCommentRepliesType(resourceType)
        });
      });
    }

    return {commentsIds: result, entities, meta};
  });
}

export function commentCreate(text, resourceType, resourceId) {
  return callApi('/comments', {
    method: 'POST',
    body: {
      text,
      resourceType,
      resourceId
    }
  });
}

export function commentMarkAsUseful(commentId, resourceType, useful) {
  return callApi(`/comments/${resourceType}/${commentId}/useful`, {
    method: 'POST',
    body: {
      useful
    }
  });
}



/** WEBPACK FOOTER **
 ** ./src/members/state/comments/api.js
 **/